<div class="social-media-wrapper">
  <p class="me-2 mb-0 body--s">
    {{ 'footer.findUsOn' | cxTranslate }}
  </p>
  <span>
    <ng-container *ngFor=" let socialMediaLink$ of links">
      <ng-container *ngIf="socialMediaLink$ | async as socialMediaLink">
        <ng-container *ngIf="socialMediaLink.url">
          <cx-generic-link [target]="socialMediaLink.target" [url]="socialMediaLink.url"
                           [title]="socialMediaLink.linkName"
                           class="p-1 dcp-footer-icon text-center me-2 ds-icon ds-icon--{{socialMediaLink.linkName.toLowerCase()}} focusable focusable__element">
          </cx-generic-link>
        </ng-container>
      </ng-container>
    </ng-container>
  </span>
</div>
